import {
    COUNTRY_LIST_REQUEST,
    COUNTRY_LIST_SUCCESS,
    COUNTRY_LIST_FAIL
} from '../constants/countryConstants'
import api from '../core/api';

export const listCountry = () => async (dispatch, getState) => {
    try {
        dispatch({ type: COUNTRY_LIST_REQUEST })

        const { data } = await api.get(
            `/country`
        )

        var dt = data.Result

        if(typeof(dt)=='string'){
            dispatch({
                type: COUNTRY_LIST_FAIL,
                payload: data.Result
            })
        }else{
            dispatch({
                type: COUNTRY_LIST_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: COUNTRY_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}